<script setup lang="ts">
import { computed } from "vue";
import { PowerUpLayout } from "@vendata/power-up-clients-common";
import { configureAuthApp } from "@saflib/ory-kratos-spa";
import { linkToHrefWithHost } from "@saflib/links";
import { accountLinks, appLinks } from "@vendata/power-up-links";

configureAuthApp({
  showFlowHeaders: false,
  postAuthFallbackHref: computed(() => linkToHrefWithHost(appLinks.home)),
  postRecoverySettingsHref: () => (settingsFlowId: string) =>
    linkToHrefWithHost(accountLinks.password, {
      params: { flow: settingsFlowId },
    }),
});
</script>

<template>
  <PowerUpLayout :logged-in="true" nav-appearance="app" disable-container>
    <router-view />
  </PowerUpLayout>
</template>

<style scoped></style>
